if(typeof ProductBooking !== undefined ) {
  class ProductBooking extends HTMLElement {
    constructor() {
      super();
      this.classes = ['active']
      this.modal = this.querySelector('[data-modal]');
      this.querySelector('[data-open-custom]').addEventListener('click', () => {
        this.open();
      })
      this.querySelector('[data-close]').addEventListener('click', () => {
        this.close();
      })
      this.modal.addEventListener('transitionend', (e) => {
        if(this.modal.classList.contains('visible')) { 
          return; 
        }
        console.log('abc');
        this.querySelector('[data-modal]').classList.remove('active');
      })
    }
  
    open(){
      this.querySelector('[data-modal]').classList.add(...this.classes)
      setTimeout(() => {
        this.modal.classList.add('visible');
      }, 50)
    }
    close() {
      this.querySelector('[data-modal]').classList.remove("visible");
    }
  }
  customElements.define('product-booking', ProductBooking);
  
}